import { Row } from "reactstrap";
import React from "react";
import DataTable from "react-data-table-component";
import {
  Col,
  Card,
  CardBody,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import { ResultColumns } from "./SortAndColumns/ResultColumns";
import { CategoryConfig } from "./SortAndColumns/CategoryConfig";

function JuniorHandlingResultsAttendee({ data }) {


 if (!data || data.length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
        <h6 className="text-muted">No results found for this filter</h6>
      </div>
    );
  }

  // Extract all attendees from all events, filtering out empty entries
  const attendees = data.flatMap(event => {
    if (!event.attendees || event.attendees.length === 0) return [];

    return event.attendees.filter(attendee => {
      // Filter out entries that indicate "no qualifiers"
      return attendee.dog_data?.dog_title !== "There were no qualifiers in this event." &&
        attendee.dog_data?.dog_name !== "";
    }).map(attendee => ({
      ...attendee,
      event_category: event.event_category // Add event category to each attendee
    }));
  });


  if (attendees.length === 0) {
    return 'not';
  }else if(attendees[0]?.no_qualifiers === true){
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
        <h6 className="text-muted">No results found for this filter</h6>
      </div>
    );
  }

  const category = data[0]?.event_category || 'Junior Handling (Conformation)';
  const config = CategoryConfig[category] || CategoryConfig["Other"];

  // const attendees = data.flatMap(event => event.attendees || []);

  return (
    <div>
      <ToastContainer />
      {config?.header(data[0], attendees)}
      <Card className="my-2" style={{ padding: 10 }}>
        <DataTable
          columns={ResultColumns(category)}
          data={attendees}
          highlightOnHover
          className="publicRankingTable"
          sortIcon={<FilterListIcon />}
        />
      </Card>
    </div>
  );
}

export default JuniorHandlingResultsAttendee;
